import { render, staticRenderFns } from "./MenuWrap.vue?vue&type=template&id=2ccebfd2&scoped=true&"
import script from "./MenuWrap.vue?vue&type=script&lang=ts&"
export * from "./MenuWrap.vue?vue&type=script&lang=ts&"
import style0 from "./MenuWrap.vue?vue&type=style&index=0&id=2ccebfd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccebfd2",
  null
  
)

export default component.exports